import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { Notification } from "#/types/notification";

export const notificationApi = {
  getAll: (
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Notification[]>>> =>
    api.get("/notification", { params }),
  getUnreadCount: (): Promise<ApiResponse<{ count: number }>> =>
    api.get("/notification/unread-count"),
  markAsRead: (id: number): Promise<ApiResponse<Notification>> =>
    api.patch(`/notification/${id}/mark-as-read`),
};
